/* eslint-disable */

import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { MainLayout } from '../layouts';

import { SliceZone } from '../components';

export const query = graphql`
  query LandingQuery($uid: String!) {
    prismic {
      landing(lang: "en-us", uid: $uid) {
        _meta {
          lang
          lastPublicationDate
          type
          uid
        }
        body {
        ... on PRISMIC_LandingBodyHerotext {
          type
            label
            primary {
              fullscreen
              large_text
              text_color
              background_color
              background_image
              display_primary_cta
              display_secondary_cta
              heading
              primary_cta_color
              primary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              primary_cta_text
              secondary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              secondary_cta_text
              subheading
              text_alignment
            }
        },
        ... on PRISMIC_LandingBodyHerovideo {
          type
            label
            primary {
              fullscreen
              large_text
              cta_text_primary
              cta_text_secondary
              cta_url_primary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              cta_url_secondary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              heading_color
              hero_video_color_overlay
              hero_video_placeholder_img
              hero_video_url {
                ... on PRISMIC__FileLink {
                  _linkType
                  url
                }
              }
              subheading
              subheading_color
              text_color
              video_icon
              video_timestamp
              video_timestamp_color
              video_title
              video_title_color
              video_wistia_id
            }
        },
        ... on PRISMIC_LandingBodyCarouseltestimonial {
          type
            label
            primary {
              background_color
              background_image
              text_color
              heading
              heading_color
              subheading1
              subheading_color
            }
            fields {
              logo
              quote
              author
              author_details
              avatar
              link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_text
            }
        },
        ... on PRISMIC_LandingBodyListalternatingv2 {
          type
            label
            fields {
              list_alt_image
              list_alt_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              list_alt_link_text
              list_alt_text
              list_alt_title
              list_link_color
              list_text_color
              list_title_color
            }
            primary {
              background_color
              heading
              subheading
              background_image
              heading_color
              subheading_color
              text_color
            }
        },
        ... on PRISMIC_LandingBodyListgridv2 {
          type
            label
            primary {
              background_color
              background_image
              heading
              heading_color
              list_column_number
              list_item_alignment_position
              list_item_heading_color
              list_item_text_color
              list_item_icon_position
              list_item_icon_size
              subheading
              subheading_color
              text_color
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              annotation
            }
            fields {
              list_item_heading
              list_item_icon
              list_item_text
              list_item_url_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              list_item_url_text
            }
        },
        ... on PRISMIC_LandingBodyContentblock {
          type
            label
            primary {
              target_name
              background_color
              background_image
              content
              content_text_alignment
              heading
              heading_color
              image
              subheading
              subheading_color
              text_color
              wistia_id
            }
        },
        ... on PRISMIC_LandingBodyCardsv2 {
          type
            label
            fields {
              image
              link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              text
              text_color
              title1
              title_color
            }
            primary {
              background_color
              columns
              content_alignment
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              heading_color
              subheading
              subheading_color
              text_color
              background_image
            }
        },
        ... on PRISMIC_LandingBodyCardshoverlinks {
          type
            label
            fields {
              card_icon
              card_text
              card_title
              link_1 {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_1_text
              link_2 {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_2_text
              link_3 {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_3_text
              link_4 {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_4_text
              link_only_card
            }
            primary {
              background_color
              subtitle
              title1
              background_image
            }
        },
        ... on PRISMIC_LandingBodyQuote {
          type
            label
            primary {
              quote
              align_content
              author_details
              author_image
              author_name
              background_color
              background_image
              logo
              text_color
            }
        },
        ... on PRISMIC_LandingBodyCtaband {
          type
            label
            primary {
              text_color
              background_color
              cta_band
              cta_primary_background_color
              cta_text_primary
              cta_text_secondary
              cta_url_primary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              cta_url_secondary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              subheading
              background_image
            }
        },
        ... on PRISMIC_LandingBodySignupformband {
          type
label
primary {
  fullscreen
  background_color
  background_image
  large_text
  email_placeholder
  form_title
  headline
  headline_color
  name_placeholder
  password_placeholder
  subheadline
  subheadline_color
  submit_button_text
  subscript
  text_color
}
fields {
  button_link {
    ... on PRISMIC__ExternalLink {
      _linkType
      url
    }
  }
  button_text
  icon
}
        },
        ... on PRISMIC_LandingBodyDynamicformbuilder {
          type
          label
          primary {
            footer_form_text
            form_anchor_name
            form_post_location
            header_form_text
            marketo_form_id
            munchkin_account_id
            sub_header_form_text
            thank_you_message
            analytics_track
            analytics_action
          }
          fields {
            field_alphanumeric
            field_column_width
            field_error_message
            field_max_length
            field_name
            field_placeholder
            field_post_name
            field_required
            field_type
            field_value
            section_header
            section_sub_header
          }
        },
        ... on PRISMIC_LandingBodyFeatureslist {
          type
            label
            primary {
              background_color
              background_image
              cta_button_color
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              item_text_color
              heading_color
              item_title_color
              subheading
              subheading_color
              text_color
            }
            fields {
              item_icon
              item_text
              item_title
            }
        }}
        date
        description
        path
        title
        open_graph_image
      }
    }
  }
`;

const Landing = ({ data, location }) =>
  data.prismic.landing ? (
    <MainLayout location={location} layout='landing'>
    <Helmet>
      <title>{(data.prismic.landing.title[0] && data.prismic.landing.title[0].text) || 'DigitalOcean'}</title>
      <link rel="canonical" href={data.prismic.landing.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.landing.path : 'https://www.digitalocean.com' + data.prismic.landing.path + '/'} />
      <meta
        name="description"
        content={
          data.prismic.landing.description ||
          'Helping millions of developers easily build, test, manage, and scale applications of any size – faster than ever before.'
        }
      />
      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:title" content={data.prismic.landing.title[0] ? data.prismic.landing.title[0].text : 'DigitalOcean'} />
      <meta name="twitter:description" content={data.prismic.landing.description ? data.prismic.landing.description : 'DigitalOcean'} />
      <meta name="twitter:image" property={data.prismic.landing.open_graph_image ? data.prismic.landing.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={data.prismic.landing.description ? data.prismic.landing.description : 'DigitalOcean'} />
      <meta property="og:title" content={data.prismic.landing.title[0] ? data.prismic.landing.title[0].text : 'DigitalOcean'} />
      <meta property="og:url" content={data.prismic.landing.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.landing.path : 'https://www.digitalocean.com' + data.prismic.landing.path + '/'} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="600" />
      <meta property="og:image" content={data.prismic.landing.open_graph_image ? data.prismic.landing.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
    </Helmet>
      <SliceZone allSlices={data.prismic.landing.body} />
    </MainLayout>
  ) : null;

Landing.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Landing;
